// 纸张标准
const ISO_216 = new Map([
    ['841*1189', 'A0'],
    ['594*841', 'A1'],
    ['420*594', 'A2'],
    ['297*420', 'A3'],
    ['210*297', 'A4'],
    ['148*210', 'A5'],
    ['105*148', 'A6'],
    ['74*105', 'A7'],
    ['52*74', 'A8'],
    ['37*52', 'A9'],
    ['26*37', 'A10'],
    ['1000*1414', 'B0'],
    ['707*1000', 'B1'],
    ['500*707', 'B2'],
    ['353*500', 'B3'],
    ['250*353', 'B4'],
    ['176*250', 'B5'],
    ['125*176', 'B6'],
    ['88*125', 'B7'],
    ['62*88', 'B8'],
    ['44*62', 'B9'],
    ['31*44', 'B10'],
    ['917*1297', 'C0'],
    ['648*917', 'C1'],
    ['458*648', 'C2'],
    ['324*458', 'C3'],
    ['229*324', 'C4'],
    ['162*229', 'C5'],
    ['114*162', 'C6'],
    ['81*114', 'C7'],
    ['57*81', 'C8'],
    ['110*220', 'DL'],
    ['81*162', 'C7/6']
])

export default class ISO_PAGE_SPEC {
    constructor(width = 0, height = 0) {
        this.width = width
        this.height = height
        this.isVertical = width < height
    }

    get spce() {
        return `${this.width}mm * ${this.height}mm`
    }

    get type() {
        let width = this.isVertical ? this.width : this.height;
        let height = this.isVertical ? this.height : this.width;
        return ISO_216.get(`${width}*${height}`) || '其他'
    }

    get directionDesc() {
        return this.isVertical ? '纵向' : '横向';
    }
}